import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useWindowSize from 'shared/hooks/use-window-size';
interface EventsSkeletonInterface {
  revenueLength: number;
}
const EventsSkeleton = t0 => {
  const $ = _c(6);
  const {
    revenueLength
  } = t0;
  const {
    width
  } = useWindowSize();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Array.from(Array(8).keys()).map(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== revenueLength || $[2] !== width) {
    t2 = revenueLength > 3 && Array.from(Array(width > 1023 && width < 1150 ? 13 : 4).keys()).map(_temp2);
    $[1] = revenueLength;
    $[2] = width;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <><div className="flex flex-col px-[25px]">{t1}{t2}</div></>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default EventsSkeleton;
function _temp(el, idx) {
  return <div key={idx}><hr className="color-text-primary opacity-10" /><div className="flex flex gap-2 py-4"><div className="bg-skeleton-primary flex h-[24px] min-w-[24px] animate-pulse rounded-full text-transparent">.</div><div className="flex w-full flex-col gap-1"><div className="flex items-center justify-between"><div className="bg-skeleton-primary w-[80px] animate-pulse rounded-md text-transparent">.</div><div className="bg-skeleton-primary h-[20.4px] w-[100px] animate-pulse rounded-md text-transparent">.</div></div><div className="bg-skeleton-primary h-[21.7px] animate-pulse rounded-md text-transparent">.</div></div></div></div>;
}
function _temp2(el_0, idx_0) {
  return <div key={idx_0}><hr className="color-text-primary opacity-10" /><div className="flex flex gap-2 py-4"><div className="bg-skeleton-primary flex h-[24px] min-w-[24px] animate-pulse rounded-full text-transparent">.</div><div className="flex w-full flex-col gap-1"><div className="flex items-center justify-between"><div className="bg-skeleton-primary w-[80px] animate-pulse rounded-md text-transparent">.</div><div className="bg-skeleton-primary h-[20.4px] w-[100px] animate-pulse rounded-md text-transparent">.</div></div><div className="bg-skeleton-primary h-[21.7px] animate-pulse rounded-md text-transparent">.</div></div></div></div>;
}